import { first } from "rxjs/operators";
export class GetFollowersUseCaseImpl {
    constructor(userRepository) {
        this.userRepository = userRepository;
    }
    async getFollowersByUsername(username) {
        const user = await this.userRepository.findUserByUsername(username);
        return this.getUsersByIds(user.followers);
    }
    async getFollowingByUsername(username) {
        const user = await this.userRepository.findUserByUsername(username);
        return this.getUsersByIds(user.following);
    }
    getUsersByIds(ids) {
        const promises = ids.map(id => {
            return this.getUserById(id);
        });
        return Promise.all(promises);
    }
    getUserById(id) {
        return this.userRepository.findUserById(id).pipe(first()).toPromise();
    }
}
